export const commonUtils = {
    calcAge: (birthDate) => {
        if(!birthDate){
            return '';
        }
        const today = new Date();
        const birth = new Date(birthDate);
        let age = today.getFullYear() - birth.getFullYear();
        const m = today.getMonth() - birth.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
            age--;
        }
        return age;
    },
    // 디바이스명
    getDeviceInfo() {
        if (window.Android && window.Android.getDeviceInfo) {
            return window.Android.getDeviceInfo();
        } else {
            return this.parseUserAgent();
        }
    },
    parseUserAgent() {
        const userAgent = navigator.userAgent.toLowerCase();
    
        if (userAgent.includes('win')) return 'Windows';
        if (userAgent.includes('mac')) return 'macOS';
        if (userAgent.includes('linux')) return 'Linux';
        if (userAgent.includes('android')) return 'Android';
        if (userAgent.includes('iphone') || userAgent.includes('ipad')) return 'iOS';
        
        return 'Unknown'
    },
};
